import React, { useEffect, useState } from "react";
import "../../styles/css/Chart.css";
import NavigationBar from "../NavigationBar";
import SideNavigation from "../SideNavigation";
import { Button, Alert, Col, Form } from "react-bootstrap";
import micro_reporter_api from "../../apis/micro-reporter-api";
import excel_api from "../../apis/excel-api";
import { CHART_LIST } from "../../config/constants";
import ChartList from "./ChartList";
import Select from "react-select";
import Utils from "../../libraries/utils";
import moment from "moment";
import lineChart from "../../assets/img/chart-data/line-chart.png";
import barChart from "../../assets/img/chart-data/bar-chart.png";
import pieChart from "../../assets/img/chart-data/pie-chart.png";

const Chart = (props) => {
  const [chartType, setChartType] = useState([]);
  const [selectedChart, setSelectedChart] = useState(undefined);
  const [fieldList, setFieldList] = useState([]);
  const [measureSelectedField, setMeasureSelectedField] = useState([]);
  const [pieField, setPieField] = useState();
  const [xField, setXField] = useState();
  const [yField, setYField] = useState();
  const [dataSourceField, setDataSourceField] = useState();
  const [uniqueValue, setUniqueValue] = useState([]);
  const [teamPerformanceChart, setTeamPerformanceChart] = useState();
  const [returnChart, setReturnChart] = useState();
  const [createOrUpdate, setCreateOrUpdate] = useState();
  const [projectName, setProjectName] = useState();
  const [chartTitle, setChartTitle] = useState();
  const [displayValue, setDisplayValue] = useState();
  const [datasetValues, setDatasetValues] = useState([]);
  const [multiselect, setMultiSelect] = useState([]);
  const [isMultiSelectDisable, setIsMultiSelectDisable] = useState(true);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showDuplicateError, setShowDuplicateError] = useState(false);

  let errorMessage = "Can not draw the chart with selected fields!";
  let duplicateError =
    "You can not save this chart with this fields because this chart already created.";

  useEffect(() => {
    setChartType(CHART_LIST);
    getFieldList();
    whichListIsShowing();
    if (datasetValues.length > 0) {
      document.querySelectorAll(".gray").forEach((x) => {
        x.classList.value = " ";
      });
    }
  }, [selectedChart, datasetValues]);

  const getFieldList = () => {
    try {
      Utils.loadingScreen("show");
      (async () => {
        let id = new URLSearchParams(window.location.search).get("reportId");
        await micro_reporter_api
          .get(`/micro-reporter/report/get-column-info?reportId=` + id)
          .then((response) => {
            setFieldList(response.data.fieldList);
            let measureList = [];
            response.data.fieldList.map((x) => {
              if (x.type === "Measure") {
                measureList.push(x);
              }
            });
            setChartTitle(
              JSON.parse(localStorage.getItem("user")).role === "ADMIN"
                ? response.data.databaseConnectionName +
                    " - " +
                    response.data.name
                : ""
            );
            setProjectName(response.data.name);
            setMeasureSelectedField(measureList);
            Utils.loadingScreen("hide");
          });
      })();
    } catch (e) {
      Utils.loadingScreen("hide");
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const whichListIsShowing = () => {
    //displayValue => ]hangi chart secildiyse ilgili itemlar ekrana basilmasi icin setlenen bir deger
    if (selectedChart === "Bar" || selectedChart === "Line") {
      setDisplayValue(false);
    } else if (selectedChart === "Pie") {
      setDisplayValue(true);
    }
  };

  const getWhileCreating = (e) => {
    if (teamPerformanceChart) {
      teamPerformanceChart.destroy();
    }
    setShowErrorMessage(false);
    getFieldList();
    if (e) {
      if (e.id && e.id !== 0) {
        getUniqeValues(e.subject);
        selectMultiSelect();
      }
      setXField(e.horizontalAxisColumn);
      setYField(e.verticalAxisColumn);
      setDataSourceField(e.subject);
      setPieField(e.pieColumn);
      setUniqueValue(e.selectedSubjects);
      setMultiSelect(e.selectedSubjects);
      setSelectedChart(e.chartType);
      setCreateOrUpdate(e.id);
    }
  };

  const createChartButton = (e) => {
    getWhileCreating(e);
    let user = JSON.parse(localStorage.getItem("user"));
    let id = new URLSearchParams(window.location.search).get("reportId");
    let uniqueList = [];
    let value;
    if (e) {
      if (e.selectedSubjects && e.selectedSubjects.length > 0) {
        e.selectedSubjects.map((x) => {
          uniqueList.push(x.label);
        });
      }
      value = {
        reportId: id,
        chartType: e.chartType,
        subject: e.subject,
        selectedSubjects: uniqueList,
        horizontalAxisColumn:
          e.chartType === "Pie" ? null : e.horizontalAxisColumn,
        verticalAxisColumn: e.chartType === "Pie" ? null : e.verticalAxisColumn,
        pieColumn: e.chartType === "Pie" ? e.pieColumn : null,
      };
      setChartTitle(e.name);
    } else {
      if (uniqueValue && uniqueValue.length > 0) {
        uniqueValue.map((x) => {
          uniqueList.push(x.label);
        });
      }
      value = {
        reportId: id,
        chartType: selectedChart,
        subject: dataSourceField,
        selectedSubjects: uniqueList,
        horizontalAxisColumn: selectedChart === "Pie" ? null : xField,
        verticalAxisColumn: selectedChart === "Pie" ? null : yField,
        pieColumn: selectedChart === "Pie" ? pieField : null,
      };
    }
    try {
      Utils.loadingScreen("show");
      (async () => {
        let headers = {
          userId: user.id,
          username: user.username,
          relatedName: encodeURIComponent(nameGenerator()),
          relatedId: value.reportId,
        };
        const config = { headers };
        await micro_reporter_api
          .post("/micro-reporter/chart-detail/chart-data", value, config)
          .then((response) => {
            moment.locale("tr");
            let m = moment(new Date());
            let fileName = m.format("DD-MM-YYYY") + "-" + projectName;

            generateExcelChart(response.data, fileName);
            Utils.loadingScreen("hide");
          });
      })();
    } catch (e) {
      setShowErrorMessage(true);
      Utils.loadingScreen("hide");
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const generateExcelChart = (generateExcel, fileName) => {
    (async () => {
      try {
        Utils.loadingScreen("show");
        await excel_api
          .post("/generate-excel", generateExcel, {
            responseType: "blob",
            contentType: "application/json",
          })
          .then((response) => {
            Utils.downloadFile(response.data, fileName);
          });
      } catch (err) {
        Utils.loadingScreen("hide");
      }
    })();
  };

  const nameGenerator = () => {
    let id = new URLSearchParams(window.location.search).get("reportId");
    if (selectedChart === "Pie") {
      return (
        pieField +
        " - " +
        dataSourceField +
        " ( " +
        selectedChart +
        " Chart - " +
        id +
        " )"
      );
    } else {
      return (
        xField +
        " - " +
        yField +
        " ( " +
        dataSourceField +
        " / " +
        selectedChart +
        " Chart - " +
        id +
        " )"
      );
    }
  };

  const selectChart = (event) => {
    resetForm(event.value);
    setSelectedChart(event.value);
  };

  const resetForm = (chartType) => {
    if (chartType === "Pie") {
      setXField(undefined);
      setYField(undefined);
    }

    setPieField(undefined);
    //setUniqueValue(undefined);
    setCreateOrUpdate(null);
  };

  const setDataSource = (item) => {
    //dataset secilince unique valuler doluyor
    setDataSourceField(item);
    getUniqeValues(item);
    selectMultiSelect([]);
  };

  const getUniqeValues = (item) => {
    try {
      Utils.loadingScreen("show");
      (async () => {
        let id = new URLSearchParams(window.location.search).get("reportId");
        await micro_reporter_api
          .get(
            `/micro-reporter/report/unique-values?reportId=` +
              id +
              `&columnName=` +
              item
          )
          .then((response) => {
            setDatasetValues(response.data);
            setIsMultiSelectDisable(false);
            Utils.loadingScreen("hide");
          });
      })();
    } catch (e) {
      Utils.loadingScreen("hide");
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const selectMultiSelect = (event) => {
    if (createOrUpdate && createOrUpdate !== 0) {
      setMultiSelect(uniqueValue);
    }
    if (event) {
      event.length && event.find((option) => option.value === "all")
        ? (() => {
            setMultiSelect(datasetValues.slice(0));
            setUniqueValue(datasetValues.slice(0));
          })()
        : (() => {
            setMultiSelect(event);
            setUniqueValue(event);
          })();
    }
  };

  const getChartLogo = () => {
    let url;
    switch (selectedChart) {
      case "Line":
        url = lineChart;
        break;

      case "Bar":
        url = barChart;
        break;

      case "Pie":
        url = pieChart;
        break;

      default:
        break;
    }

    return url;
  };

  const getStyle = () => {
    let style;
    switch (selectedChart) {
      case "Pie":
        style = { width: "300px", height: "300px" };
        break;

      default:
        style = { width: "400px", height: "300px" };
        break;
    }

    return style;
  };

  return (
    <div>
      <SideNavigation current="reports" />
      <div className="page-order">
        <NavigationBar />
        <ChartList
          returnChart={returnChart}
          setReturnChart={setReturnChart}
          createChartButton={createChartButton}
          setSelectedChart={setSelectedChart}
        />
        <div id="chart">
          <h5 className="page-title">{chartTitle}</h5>
          {showDuplicateError ? (
            <Alert variant="danger">{duplicateError}</Alert>
          ) : null}
          <div id="selected-wrapper" md="12">
            {JSON.parse(localStorage.getItem("user")).role === "ADMIN" ? (
              <div>
                <Form>
                  <Form.Row>
                    <Form.Group as={Col} md="2" controlId="selectChart">
                      <Form.Label>Select Chart Type</Form.Label>
                      <Select
                        options={[...chartType]}
                        onChange={(event) => selectChart(event)}
                        placeholder="Select Chart Type"
                      />
                    </Form.Group>

                    {displayValue && selectedChart ? (
                      <Form.Group as={Col} md="2" controlId="dataSource">
                        <Form.Label>Select Data Set</Form.Label>
                        <Select
                          options={[...fieldList]}
                          onChange={(event) => setDataSource(event.value)}
                          placeholder="Dataset Values"
                        />
                      </Form.Group>
                    ) : !displayValue && selectedChart ? (
                      <Form.Group as={Col} md="2" controlId="dataSource">
                        <Form.Label>Select Data Set</Form.Label>
                        <Select
                          options={[...fieldList]}
                          onChange={(event) => setDataSource(event.value)}
                          placeholder="Dataset Values"
                        />
                      </Form.Group>
                    ) : (
                      ""
                    )}

                    {selectedChart ? (
                      <Form.Group as={Col} md="2">
                        <Form.Label>Dataset Values</Form.Label>
                        <Select
                          isDisabled={isMultiSelectDisable}
                          options={[
                            { label: "Select All", value: "all" },
                            ...datasetValues,
                          ]}
                          value={multiselect}
                          onChange={(event) => selectMultiSelect(event)}
                          isMulti
                          placeholder="Dataset Values"
                        />
                      </Form.Group>
                    ) : (
                      ""
                    )}

                    {!displayValue && selectedChart ? (
                      <Form.Group
                        as={Col}
                        md="2"
                        controlId="xField"
                        if={displayValue}
                      >
                        <Form.Label>X Axis</Form.Label>
                        <Select
                          options={[...fieldList]}
                          onChange={(event) => setXField(event.value)}
                          placeholder="X Axis"
                        />
                      </Form.Group>
                    ) : (
                      ""
                    )}

                    {!displayValue && selectedChart ? (
                      <Form.Group as={Col} md="2" controlId="yField">
                        <Form.Label>Y Axis</Form.Label>
                        <Select
                          options={[...measureSelectedField]}
                          onChange={(event) => setYField(event.value)}
                          placeholder="Y Axis"
                        />
                      </Form.Group>
                    ) : (
                      ""
                    )}

                    {displayValue && selectedChart ? (
                      <Form.Group as={Col} md="2" controlId="pieField">
                        <Form.Label>Pie Value Field</Form.Label>
                        <Select
                          options={[...measureSelectedField]}
                          onChange={(event) => setPieField(event.value)}
                          placeholder="Pie Value Field"
                        />
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    {selectedChart && (
                      <div>
                        <Form.Label></Form.Label>
                        <Button
                          variant="primary"
                          disabled={
                            selectedChart === "Pie"
                              ? !(
                                  dataSourceField &&
                                  multiselect.length > 0 &&
                                  pieField
                                )
                              : !(
                                  xField &&
                                  dataSourceField &&
                                  yField &&
                                  multiselect.length > 0
                                )
                          }
                          onClick={() => createChartButton()}
                          style={{
                            padding: "0",
                            height: "38.4px",
                            marginTop: "27px",
                            float: "right",
                            backgroundColor: "#6c976c",
                            borderColor: "#6c976c",
                          }}
                        >
                          <a className="link">İndir</a>
                        </Button>
                      </div>
                    )}
                  </Form.Row>
                </Form>
                {selectedChart ? (
                  <div>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      Örnek Chart:
                    </div>
                    <img
                      style={getStyle()}
                      src={getChartLogo()}
                      alt="chart-logo"
                    />
                  </div>
                ) : null}
              </div>
            ) : null}
            <div>
              {showErrorMessage && (
                <Alert variant="danger">{errorMessage}</Alert>
              )}{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chart;
